import { AnalyticsData, AnalyticsMetadata } from "@/tracking/analytics/analyticsTracker.ts";

const eventsURL = import.meta.env.VITE_EVENTS_URL

export async function postEvent(eventName: string, eventData: AnalyticsData, metadata: AnalyticsMetadata): Promise<void> {

  const data = {
    ...eventData,
    location: window.location.pathname,
    window_location: window.location.toString(),
  }

  const event = {
    n: eventName,
    data: data,
    src: 'toolkit',
    com: 'frontend',
    t: new Date(),
    l: new Date(),
    ...metadata
  }

  const headers = new Headers({
    'Content-Type': 'application/json; charset=UTF-8'
  })

  const response = await fetch(
    `${eventsURL}/event`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(event)
    }
  )
  if (response.status >= 300) {
    const responseJSON = await response.json()
    console.warn(`Non-200 response while posting event. status: ${response.status}. response: ${responseJSON}`)
  }
}